exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-activity-portal-row .activity-portal-state--locked{opacity:.5;cursor:not-allowed}.fts-activity-portal-row .activity-portal-pick{display:flex;align-items:center;gap:.75rem;padding:0 0 .625rem}.fts-activity-portal-row .activity-portal-select{margin-left:auto;min-width:0;max-width:60%;height:1.75rem;padding:0 .5rem;border:1px solid var(--fts-border);border-radius:.375rem;background:var(--fts-card-background);color:var(--fts-text);font:inherit;font-size:.75rem}.fts-activity-portal-row .activity-portal-note{padding:0 0 .625rem;font-size:.6875rem;line-height:1rem;color:var(--fts-form-helper)}", ""]);

// exports
